module.exports = __webpack_public_path__ + "img/sv51.bdaf62f4.svg";